import React from "react";

import { doNothing } from "@examspark/common";

export const AsideLayoutContext = React.createContext<{
  requestAside: Record<string, boolean>;
  onRequestAside: (id: string, request: boolean) => void;
  asidePortalId: string;
  breakAt?: string;
}>({
  requestAside: {},
  onRequestAside: doNothing,
  asidePortalId: "unit-aside",
});
export const AsideLayoutProvider = ({
  children,
  requestAside,
  onRequestAside,
  asidePortalId,
  breakAt,
}: {
  children: React.ReactNode;
  requestAside: Record<string, boolean>;
  onRequestAside: (symbol: string, request: boolean) => void;
  asidePortalId: string;
  breakAt?: string;
}) => {
  return (
    <AsideLayoutContext.Provider
      value={{ requestAside, onRequestAside, asidePortalId, breakAt }}
    >
      {children}
    </AsideLayoutContext.Provider>
  );
};
